export default __webpack_public_path__ + "static/media/ic-inspections-management.d4f59a01.svg";